module.exports = __webpack_public_path__ + "img/title0.1fa4ad10.png";